export default "__VITE_ASSET__MGcKx78c__"